import React, {Fragment} from 'react'
import { graphql, StaticQuery, Link } from 'gatsby'
import Bell from '../../assets/tab-phone.svg'
import Computer from '../../assets/movie.svg'
import Alert from '../../assets/party.svg'
import ModalVideo from 'react-modal-video'


class VideoSection extends React.Component{
    constructor(props){
        super(props)

        this.state = {
            isOpen: false
        }

        this.openModal = this.openModal.bind(this)
    }

    openModal () {
        this.setState({isOpen: true})
    }

    render(){
        const {play, videoFrame, computerMobile, partyMobile, movieMobile} = this.props.query;
            return(
                <section className="thumb-section">
                    <div className="custom-container">
                        <div className="for-mobile arrow">
                          <a href="javascript:void(0)" onClick={() => document.getElementById('quiz').scrollIntoView({behavior: 'smooth'})}>  <svg width="17" height="10" viewBox="0 0 17 10"><path fill="#32e2b9" fillRule="nonzero" stroke="#32e2b9" d="M15.782 1.203a.53.53 0 0 0-.744 0L8.5 7.693l-6.551-6.49a.53.53 0 0 0-.744 0 .518.518 0 0 0 0 .737l6.91 6.844c.103.102.231.153.372.153.128 0 .27-.051.372-.153l6.91-6.844a.507.507 0 0 0 .013-.737z"></path></svg></a>
                        </div> 
                        <h3 style={{marginTop: 0}}>Positiv skärmtid skapar <br/> ovärderlig nyfikenhet</h3>
                        <p className="desktop">Alberts pedagogiska övningar är speciellt framtagna för yngre barn. <br/> Övningarna hjälper barnen att utveckla det logiska tänkandet och förmågan att lösa problem <br/> samtidigt som de förbereder barnen för mer avancerad matte.</p>
                        <p className="for-mobile">Alberts pedagogiska övningar är speciellt framtagna <br/> för yngre barn. Övningarna hjälper barnen att utveckla det <br/> logiska tänkandet och förmågan att lösa problem <br/> samtidigt som de förbereder barnen för mer <br/> avancerad matte.</p>
                        <a href="javascript:void(0)" onClick={this.openModal} className="play-sec" style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0}}>
                            <img src={play.publicURL} style={{top: 0, margin: 0}} />
                            <p style={{width: 'auto', color: '#32e2b9', margin: '2rem 0'}}>Se våra användare</p>
                        </a>
                        
                        <ModalVideo channel='vimeo' isOpen={this.state.isOpen} videoId='356395627' onClose={() => this.setState({isOpen: false})} />
                        
                        <div className="middle-images">
                            <figure><img src={videoFrame.publicURL}/></figure>
                        </div>
                        <ul>
                            <li>
                                <figure><Computer className="desktop"/> 
                                <img src={movieMobile.publicURL} className="for-mobile"/></figure>
                               
                                <figcaption>
                                    <h4>100% reklamfritt</h4>
                                    {/* <p>Junior fungerar på både dator och surfplatta</p> */}
                                </figcaption>
                            </li>
                            <li>
                                <figure><Bell className="desktop"/> 
                               
                                 <img src={computerMobile.publicURL} className="for-mobile"/></figure>
                                <figcaption>
                                    <h4>Tillgång via dator, surfplatta och mobil</h4>
                                    {/* <p>Ingen reklam här inte, fokus på pluggeriet!</p> */}
                                </figcaption>
                            </li>
                            
                            <li>
                                <figure><Alert className="desktop"/> 
                               <img src={partyMobile.publicURL} className="for-mobile"/></figure>
                                <figcaption>
                                    <h4>Inga köp inuti app</h4>
                                    {/* <p>Inga köp innuti appen, allt ingår i premium.</p> */}
                                </figcaption>
                            </li>
                        </ul>
                    </div>
                </section>
            )
        
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    play: file(relativePath: {regex: "/play-video/"}) {
                        publicURL
                    }
                    videoFrame: file(relativePath: {regex: "/video-frame/"}){
                        publicURL
                    }
                    googleLogo: file(relativePath: {regex: "/google-play-badge/"}){
                        publicURL
                    }
                    computerMobile: file(relativePath: {regex: "/computer-mobile/"}){
                        publicURL
                    }
                    partyMobile: file(relativePath: {regex: "/party-mobile/"}){
                        publicURL
                    }
                    movieMobile: file(relativePath: {regex: "/movie-mobile/"}){
                        publicURL
                    }
                }`
            }
        render={(data)  => (
           <VideoSection query={data} {...props}/>
        )}
    />
)